<template>
    <div class="wrapper success_base">
        <div v-if="is_leju_notice">
            <!--  加客服微信步骤-->
            <img src="../../assets/image/secondary/leju_notice.jpg" style="width: 100%;height:auto;overflow-x: hidden">
        </div>
        <div v-else>
            <div class="success_title" style="margin-top: 30px;">
                <img src="../../assets/image/secondary/success.png" class="success_title_img">
                <p class="title">恭喜您报名成功</p>
                <p class="tip">请注意查收门票短信，接听客服电话。</p>
            </div>
            <div class="success_from" style="margin: 10px auto;">
                <div class="activity_info">
                    <p v-if="name">
                        <van-icon name="manager-o" />
                        <span>{{name}}</span>
                    </p>
                    <p>
                        <van-icon name="phone-o" />
                        <span>{{phone}}</span>
                    </p>
                    <p v-if="is_brand">
                        <van-icon name="logistics" />
                        <span v-if="brand!=''">{{brand}} - </span>
                        <span v-if="series!=''">{{series}}</span>
                    </p>

                    <!-- <el-divider></el-divider> -->
                    <p>
                        <van-icon name="clock-o" />
                        <span v-if="tid==3">{{ current_time }}</span>
                        <span v-else>{{ stime_etime }}</span>
                    </p>
                    <p v-if="address != ''">
                        <van-icon name="location-o" />
                        <span>{{ address}}</span>
                    </p>
                </div>
            </div>
            <div class="success_tail">
                <img v-if="tid != 5" src="../../assets/image/secondary/friend.png" alt="尾图" />
                <img v-if="tid == 5" src="../../assets/image/secondary/tail.png" alt="尾图" />
            </div>
            <div class="success_button_copy" @click="clk_copy" style="margin-top: 20px;">
                <img src="../../assets/image/secondary/btn_copy.png" alt="复制分享" />
                <img src="../../assets/image/new_img/pointer_01.png" alt="手" class="pointer_img">
                <div class="threeCircle threeCircle_1"></div>
                <div class="threeCircle threeCircle_2"></div>
                <div class="threeCircle threeCircle_3"></div>
            </div>
        </div>
    </div>
</template>

<script>

import _wx from "@/common/_wx";
import _geturl from "@/utils/_geturl";
import lib_activity from "@/libs/lib_activity";
import cache_url from "@/cache/cache_url";
import _time from "@/utils/_time";
import _object from "@/utils/_object";
import _copyUrl from "@/common/_copyUrl";
import lib_clue from "@/libs/lib_clue";

export default {
    name: "success_base",

    data() {
        return {
            activity_id: 0, //活动ID
            tids: '', //模板id
            tid: 1, // 5是非汽车行业
            id: 0,
            channel: 0, //渠道ID
            ui: {}, //模板信息
            title: '', //
            share_theme: '', //分享主题
            theme: '',
            stime: 0,
            etime: 0,
            stime_etime: '', // 活动时间
            address: '', // 活动地点
            is_stop: false,
            name: '', //姓名
            phone: undefined, //电话
            brand: '', //品牌
            series: '', //车型
            is_brand: false, //是否有车型
            is_leju_notice: false,
            current_time: '', // 当前时间
        }
    },

    created() {

        // 地址栏信息
        this.activity_id = _geturl("activity_id");//项目
        this.tids = _geturl("tids");//模板
        this.channel = _geturl("channel");//渠道
        this.id = _geturl('id');

        if (this.activity_id == 691 || this.activity_id == 678) {
            this.is_leju_notice = true
        } else {
            this.is_leju_notice = false
        }

        //获取项目信息
        lib_activity.info(this.activity_id, this.tids, this.init_info);

        // 报名信息
        lib_clue.info(this.id, this.init_userinfo)
        
        // 报名时间
        this.current_time= _time._now()
    },
    methods: {

        //初始化项目信息 data是lib_activity.info的response.data
        init_info(data) {
            // console.log(data)
            this.title = data.activity.theme;
            document.title = this.title;
            this.share_theme = data.activity.share_theme;
            this.stime = data.activity.stime;
            this.etime = data.activity.etime;
            this.stime_etime = _time._range_date(this.stime * 1000, this.etime * 1000);
            this.address = data.activity.address;
            this.tid = data.activity.tid;
            this.ui = data.ui;
            // 项目结束
            if (!data.activity.state || (_time._current() > data.activity.etime)) {
                this.is_stop = true;
                return;
            }

            // 分享： ui存在再分享
            if (_object._length(this.ui) > 0) {
                this.share();
            }
        },


        init_userinfo(data) {
            // console.log(data, '报名信息')
            this.name = data.name;
            this.phone = data.phone;
            if (data.brand_name || data.series_name) {
                this.is_brand = true
                this.brand = data.brand_name
                this.series = data.series_name
                // this.brand = data.brand_name + ' - ' + data.series_name
            }
        },
        // 分享
        share() {
            let that = this;
            lib_activity.share(function (data) {
                let options = {};
                options.title = that.title;
                options.desc = that.share_theme;
                options.link = window.location.href;
                options.image = that.ui.share;

                _wx.js_api(data, _wx.share, options);
            })
        },
        // 复制
        clk_copy() {
            let url = cache_url.empty() ? window.location.href : cache_url.get();
            _copyUrl.copyUrl("@ [" + this.theme + "] 我已领取了门票，和我一起来看看!>>" + ' ' + url)
        },

    }
}
</script>

<style scoped lang="less">
@import "../../assets/style/secondary/base.less";
@import "../../assets/style/autoshow/form.less";
// form
@import "../../assets/style/common/successful.less"; // 成功

/deep/ .el-divider--horizontal {
    margin: 10px 0;
}

.activity_info {

    p {
        margin-bottom: 6px;
    }

    span {
        color: #282828;
        font-size: 28px;
    }
}
</style>
